import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface FieldSuccessProps {
  show?: boolean;
  message?: string;
  showIcon?: boolean;
  className?: string;
}

export function FieldSuccess({
  show = false,
  message = 'Geçerli',
  showIcon = true,
  className = '',
}: FieldSuccessProps) {
  return (
    <AnimatePresence mode="wait">
      {show && (
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
          transition={{ duration: 0.2 }}
          style={{ color: '#10B981', fontSize: '14px', marginTop: '4px' }}
          className={className}
        >
          {showIcon && (
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="currentColor"
              style={{ marginRight: '4px', display: 'inline-block' }}
            >
              <path d="M8 15A7 7 0 118 1a7 7 0 010 14zm0 1A8 8 0 108 0a8 8 0 000 16z" />
              <path d="M10.97 4.97a.75.75 0 011.07 1.05l-3.99 4.99a.75.75 0 01-1.08.02L4.324 8.384a.75.75 0 111.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 01.02-.022z" />
            </svg>
          )}
          {message}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
